<template>
  <div class="gradient-row">
    <div class="privacy">
      <h4>隐私协议</h4>
      <h6>2021-02-22</h6>
      <div class="content">
        <p>
          自选基金不会在任何情况下强行劫持访问、插入恶意代码、上传隐私信息。
        </p>
        <p>
          自选基金不会收集和储存任何个人识别信息（不包括第三方提供的统计服务）。
        </p>
        <p>自选基金会上传你的自选列表用于多个浏览器同步（基于浏览器账户）。</p>
        <p>自选基金会在登录并且手动点击备份按钮后上传自选信息用于跨设备同步。</p>
        <p>自选基金会调用相关基金api用于获取基金详情。</p>
        <p>基金数据来源：天天基金网</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacy",
};
</script>

<style lang="scss" scoped>
.privacy {
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  text-align: center;

  h4 {
    font-size: 30px;
    margin: 40px 0 30px;
  }

  h6 {
    color: #999999;
    font-size: 16px;
    margin-top: 0;
  }

  .content {
    max-width: 650px;
    margin: 0 auto;
  }

  .content p {
    font-size: 17px;
    text-align: justify;
  }
}
</style>
